let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UISelectableBox from 'UIComponents/button/UISelectableBox';
import styled, { css } from 'foundations-theming/utils';
import { breakpoint, minWidthBreakpoint } from 'pricing-pages-lib/constants/Breakpoints';
import { getGAClassName } from 'pricing-pages-lib/utils/publicPageUrls';
import * as CurrencyCodes from 'self-service-api/constants/CurrencyCodes';
import { USD } from 'self-service-api/constants/CurrencyCodes';
import { useGetCurrencyStore, useSetCurrencyStore } from '../../context/CurrencyContext';
import { useGlobalLoadingState } from '../../context/GlobalLoadingStateContext';
import { validateCurrencyCode } from '../../utils/currencyUtils';
import { trackCurrencyPickerInteraction } from '../../utils/tracking/trackingEventUtils';
import { useQueryParamsEffect } from '../../utils/urls/appQueryParamUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CurrencyCodeToSymbol = {
  [CurrencyCodes.USD]: '$',
  [CurrencyCodes.EUR]: '€',
  [CurrencyCodes.GBP]: '£',
  [CurrencyCodes.AUD]: '$',
  [CurrencyCodes.JPY]: '¥',
  [CurrencyCodes.SGD]: '$',
  [CurrencyCodes.COP]: '$',
  [CurrencyCodes.CAD]: '$'
};
const CurrencySelectorWrapper = styled.div.withConfig({
  displayName: "MobileCurrencyPicker__CurrencySelectorWrapper",
  componentId: "sc-45fnu4-0"
})(["text-align:center;z-index:2;", ";.currency-symbol{margin-left:2px;", "}"], breakpoint.phone(_t || (_t = _`
    padding: 0 15px;
  `)), breakpoint.phone(_t2 || (_t2 = _`
      display: none;
    `)));
const StyledButtonGroup = styled(UIButtonGroup).withConfig({
  displayName: "MobileCurrencyPicker__StyledButtonGroup",
  componentId: "sc-45fnu4-1"
})(["position:absolute;margin-top:100px;z-index:2;", ";"], breakpoint.tablet(_t3 || (_t3 = _`
    position: static;
    margin: 1.4em 0;
  `)));
const StyledSelectableBox = styled(UISelectableBox).withConfig({
  displayName: "MobileCurrencyPicker__StyledSelectableBox",
  componentId: "sc-45fnu4-2"
})(["z-index:5;:hover{z-index:6;}.currency-selector__text{font-size:12px;}", " ", ""], minWidthBreakpoint.tablet(_t4 || (_t4 = _`
    border-left: 0 !important;

    &:first-child {
      border-top-left-radius: 0;
    }

    &:last-child {
      border-bottom-left-radius: 0;
    }
  `)), ({
  selected
}) => selected && css(["z-index:6;"]));
const MobileCurrencyPicker = () => {
  const setCurrencyStore = useSetCurrencyStore();
  const {
    availableCurrencyCodes,
    lockedCurrencyCode,
    displayedCurrencyCode
  } = useGetCurrencyStore(store => store);

  // Only update URL when we have valid currency data
  const isCurrencyDataLoading = useGlobalLoadingState('Currencies');
  useQueryParamsEffect({
    currencyCode: !isCurrencyDataLoading ? displayedCurrencyCode : undefined
  });
  const handleClick = selectedCurrencyCode => {
    const validatedCurrencyCode = validateCurrencyCode({
      availableCurrencyCodes,
      lockedCurrencyCode,
      displayedCurrencyCode,
      currencyCode: selectedCurrencyCode
    });
    const showCurrencyCodeUnit = validatedCurrencyCode === USD;
    setCurrencyStore({
      displayedCurrencyCode: validatedCurrencyCode,
      showCurrencyCodeUnit
    });
    trackCurrencyPickerInteraction({
      action: 'select currency',
      currency: validatedCurrencyCode
    });
  };
  return availableCurrencyCodes.length <= 1 ? null : /*#__PURE__*/_jsx(CurrencySelectorWrapper, {
    children: /*#__PURE__*/_jsx(StyledButtonGroup, {
      orientation: "horizontal",
      className: 'currency-selector__button-group',
      children: availableCurrencyCodes.map(currency => {
        const selected = displayedCurrencyCode === currency;
        const gaClassName = getGAClassName(`currency-pricing-${currency.toLowerCase()}`);
        return /*#__PURE__*/_jsx(StyledSelectableBox, {
          selected: selected,
          onClick: () => handleClick(currency),
          className: `p-all-2 ${gaClassName}`,
          "data-selenium-id": gaClassName,
          children: /*#__PURE__*/_jsxs("span", {
            className: `currency-selector__text ${gaClassName}`,
            children: [currency, /*#__PURE__*/_jsx("span", {
              className: "currency-symbol",
              children: CurrencyCodeToSymbol[currency]
            })]
          })
        }, currency);
      })
    })
  });
};
export default MobileCurrencyPicker;